// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"32":"35fc99ca","278":"7aa78009","281":"d5c9ad6a","329":"8b41fd0c","349":"43de7fd0","406":"3c3c8fce","754":"f7b41bf6"}[chunkId] + ".chunk.js";
};